// extracted by mini-css-extract-plugin
module.exports = {"uploadWarning":"uploadWarning_uploadWarning__3ziwg","icon":"uploadWarning_icon__3hlaC","warning":"uploadWarning_warning__zc7ZZ"};